document.documentElement.classList.remove('no-js');
// Preserve Shopify's native form submissions, CAPTCHA handling and checkout.
function focusFormResult() {
  const result = document.querySelector('[data-form-result]');
  if (result) result.focus({ preventScroll: false });
}
document.addEventListener('DOMContentLoaded', focusFormResult);
document.addEventListener('shopify:section:load', focusFormResult);
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-form] select[name="variant"]');
  if (!select) return;
  const destination = new URL(window.location.href);
  destination.searchParams.set('variant', select.value);
  destination.searchParams.delete('selling_plan');
  window.location.assign(destination.toString());
});
